"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCard = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _utils = require("../lib/utils");

var _templateObject;

var StyledCard = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  border-radius: ", ";\n  background: ", ";\n  box-sizing: border-box;\n  box-shadow: ", ";\n  ", ";\n  transition: box-shadow 0.2s ease-in-out;\n  ", "\n  ", "\n  ", "\n  ", ";\n"])), function (props) {
  return (0, _utils.getBorderRadius)('primary')(props);
}, function (props) {
  return props.bg ? props.bg : 'white';
}, function (props) {
  return props.shadow && (0, _utils.getShadow)('1');
}, function (props) {
  return props.borderColor && "border: 1px solid ".concat(props.borderColor);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, _styledSystem.width, _styledSystem.space, function (props) {
  return props.spaceAround && "padding: ".concat((0, _utils.getSpace)(props.spaceAround)(props), "px");
});

exports.StyledCard = StyledCard;